function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    align,
    alignFooter,
    expanded,
    maxWidth,
    show
  } = _ref;
  var theme = useTheme();
  var borderWidth = '1px';
  var isHc = theme.mode === 'contrast';
  var paddingWithBorder = isHc ? borderWidth : '0px';
  return React.useMemo(() => ({
    root: _objectSpread({
      backdropFilter: show ? "blur(".concat(theme.level.glasswall.blur, ")") : undefined,
      backgroundColor: theme.level.glasswall.color,
      bottom: 0,
      left: 0,
      opacity: show ? 1 : 0,
      position: 'fixed',
      right: 0,
      top: 0,
      transition: 'opacity 80ms linear',
      visibility: show ? 'visible' : 'hidden',
      zIndex: theme.elevation.modal
    }, highContrastMediaQuery(theme)),
    dialog: {
      height: '100%',
      overflowX: 'hidden',
      overflowY: 'auto',
      textAlign: 'center',
      '&::after': {
        content: '" "',
        display: 'inline-block',
        height: '100%',
        verticalAlign: 'middle',
        width: 0
      }
    },
    content: _objectSpread({
      backgroundColor: theme.palette.background.container,
      borderRadius: theme.borderRadius5,
      boxShadow: theme.level.level20,
      boxSizing: 'border-box',
      color: theme.palette.foreground.default,
      display: 'inline-block',
      margin: theme.layout.size6,
      maxWidth: maxWidth || "calc(400px + ".concat(theme.orbitalModalHorizontal, " + ").concat(theme.orbitalModalHorizontal, ")"),
      padding: "calc(".concat(theme.orbitalModalVertical, " - ").concat(paddingWithBorder, ") calc(").concat(theme.orbitalModalHorizontal, " - ").concat(paddingWithBorder, ")"),
      position: 'relative',
      textAlign: align,
      verticalAlign: 'middle',
      width: expanded ? "calc(100% - ".concat(theme.layout.size6, " - ").concat(theme.layout.size6, ")") : "calc(400px + ".concat(theme.orbitalModalHorizontal, " + ").concat(theme.orbitalModalHorizontal, ")"),
      ["@media (max-width: ".concat(theme.layout.smMin, ")")]: {
        padding: "calc(".concat(theme.orbitalModalVertical, " - ").concat(paddingWithBorder, ") calc(").concat(theme.orbitalModalHorizontal, " - ").concat(paddingWithBorder, " - 8px)")
      },
      ["@media (max-width: ".concat(theme.layout.mdMax, ")")]: {
        width: "calc(100% - ".concat(theme.layout.size6, " - ").concat(theme.layout.size6, ")")
      }
    }, isHc && {
      borderColor: theme.palette.foreground.default,
      borderStyle: 'solid',
      borderWidth
    }),
    title: {
      paddingBottom: theme.layout.size5,
      ["@media (max-width: ".concat(theme.layout.smMin, ")")]: {
        paddingBottom: theme.layout.size3
      }
    },
    body: {
      '> p:not(:last-of-type)': {
        paddingBottom: theme.orbitalEight,
        ["@media (max-width: ".concat(theme.layout.smMin, ")")]: {
          paddingBottom: theme.layout.size6
        }
      }
    },
    footer: _objectSpread(_objectSpread({
      display: 'flex',
      justifyContent: alignFooter !== null && alignFooter !== void 0 ? alignFooter : align,
      paddingTop: theme.orbitalModalVertical
    }, alignFooter && {
      '& > div': {
        flexDirection: alignFooter ? 'row-reverse' : undefined,
        'button:first-child': {
          order: 0,
          marginLeft: theme.layout.size3,
          marginRight: 0
        }
      }
    }), {}, {
      ["@media (max-width: ".concat(theme.layout.smMin, ")")]: {
        paddingTop: theme.layout.size6
      }
    }),
    closeButton: {
      position: 'absolute',
      top: theme.orbitalTwo,
      right: theme.orbitalTwo
    }
  }), [align, alignFooter, expanded, isHc, maxWidth, paddingWithBorder, show, theme]);
};
export default useStyles;